import hinoki1 from "./hinoki (1).png";
import hinoki2 from "./hinoki (2).png";
import hanami1 from "./hanami (1).png";
import hanami2 from "./hanami (2).png";
import hinoki3 from "./3.png";
import hinoki4 from "./4.png";
import hinoki5 from "./5.png";
import hinoki6 from "./6.png";
import hanami3 from "./3.png";
import hanami4 from "./4.png";
import hanami5 from "./5.png";
import hanami6 from "./6.png";

const hinokiImages = [
  hinoki1,
  hinoki2,
  hanami1,
  hanami2,
  hinoki3,
  hinoki4,
  hinoki5,
  hinoki6,
  hanami3,
  hanami4,
  hanami5,
  hanami6,
];

export default hinokiImages;
